import * as ActiveStorage from 'activestorage'

ActiveStorage.start()
